import toastPrint from "../Feature/ToastPrint";
import process from "../Function/Process";
class TryCatchFinally {
    async asyncProcess(action, setLoading, callback, source){
        let result = false;
        process.setProcessTimeout(async ()=>{
            try{
                await action();
                result = true;
            }catch(ex){
                toastPrint.printErrorMessage(ex.message);
                if (source !== undefined) {
                    console.log(source);
                }
            }finally{
                if(setLoading !== undefined){
                    setLoading({isLoading:false, text:""});
                }
                if(callback !== undefined){
                    callback();
                }
            }
        }, 200);
        return result;
    }

    syncProcess(action, setLoading, callback, source){
        let result = false;
        process.setProcessTimeout(()=>{
            try{
                action();
                result = true;
            }catch(ex){
                toastPrint.printErrorMessage(ex.message);
                if (source !== undefined) {
                    console.log(source);
                }
            }finally{
                setTimeout(()=>{
                    if(setLoading !== undefined){
                      setLoading({isLoading:false, text:""});
                    }
                    if(callback !== undefined){
                        callback();
                    }  
                }, 1500);
            }
        }, 200);
        return result;
    }
}
const tryCatchFinally = new TryCatchFinally();
export default tryCatchFinally;